import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { Well } from 'react-bootstrap';
import ECFMailboxesList from './ECFMailboxesList';

const story = (descriptions, cmps) => () => (
  <div>
    <Well bsStyle="info">
      <i className="fa fa-book" /> {descriptions}
    </Well>
    <div style={{ height: '1px', margin: '0 0 20px 0', borderTop: '1px dotted silver' }} />
    {cmps}
  </div>
);

const stubActions = {
  onConnectNewExternalInboxRequested: action('onConnectNewExternalInboxRequested'),
  onEditExternalInboxRequested: action('onEditExternalInboxRequested'),
  onDisconnectExternalInboxRequested: action('onDisconnectExternalInboxRequested'),
};

storiesOf('ECFMailboxesList', module)
  .add(
    'Empty',
    story(
      'When no mailboxes are configured, user is instructed to setup a CourtDrive mailbox first',
      <ECFMailboxesList {...stubActions} config={{ external: [] }} />
    )
  )
  .add(
    'With Managed Inbox',
    story(
      'When managed inbox is setup, user is allowed to connect an external mailbox',
      <ECFMailboxesList
        {...stubActions}
        config={{
          managed: {
            prefix: 'jsmith',
          },
          external: [],
        }}
      />
    )
  )
  .add(
    'With External Inboxes',
    story(
      `User is allowed to keep adding inboxes. 
      Clicking [Edit] will trigger an edit request. 
      Clicking [Delete] will confirm with the user before firing the delete request.`,
      <ECFMailboxesList
        {...stubActions}
        config={{
          managed: { prefix: 'jsmith' },
          external: [
            {
              type: 'gmail',
              connection_secrets: {
                username: 'j.smith@gmail.com',
              },
            },
            {
              type: 'hotmail',
              connection_secrets: {
                username: 'j.smith@hotmail.com',
              },
            },
            {
              type: 'imap',
              connection_settings: {
                hostname: 'imap.example.org',
                port: 143,
                ssl: false,
              },
              connection_secrets: {
                username: 'j.smith@example.org',
              },
            },
            {
              type: 'imap',
              connection_settings: {
                hostname: 'ssl.imap.example.org',
                port: 993,
                ssl: true,
              },
              connection_secrets: {
                username: 'j.smith2@example.org',
              },
            },
          ],
        }}
      />
    )
  );



// WEBPACK FOOTER //
// ./src/User/ECFMailboxes/ECFMailboxesList.stories.jsx